export const axiomReportChartSeriesType = ['portfolio', 'benchmark', 'active']

export const DATE_FORMAT = {
  TABLE_CHART: 'MM/DD/YYYY',
  API: 'YYYY-MM-DD',
  API_DATE_TIME: 'YYYYMMDD',
  DATE_FORMAT_1: 'YYYY/MM/DD',
}

export const FACTOR_CONTRIBUTION_DRILLDOWN_KEY_L1 = 'currency_code'
export const FACTOR_CONTRIBUTION_DRILLDOWN_KEY_L2 = 'factor_sub_category'
export const FACTOR_CONTRIBUTION_DEFAULT_SORT_KEY = 'factor_sub_category_sort'
export const AG_GRID_COLUMN_AGGREGATION_FUNC: { [key: string]: string } = {
  sum: 'sum',
  min: 'min',
  max: 'max',
  count: 'count',
  average: 'avg',
  first: 'first',
  last: 'last',
}

export const COLUMN_FORMATTING_TYPE: { [key: string]: string } = {
  percentage: '%',
  'basis points': 'bps',
  number: '',
  currency: '',
}

export const NO_ACCESS_ERR_MSG =
  "You don't have access to view. Please connect with your Manager / IT department to get the access."

// Shared TTL for any client-side cache of portfolio/benchmark lists (Scenario
// Builder, Report Schedules, RA Dashboard) — change this single value to
// adjust how long a cached list is considered fresh before being refetched.
export const PORTFOLIO_BENCHMARK_CACHE_TTL_MS = 4 * 60 * 60 * 1000 // 4 hours

// Minimum tracked DB schema version (as returned by GET /reportDashboard/api/v1/schema-version,
// e.g. "17.3.42") needed to unlock each Factor Analytics capability. Compared
// as a full ordered tuple — NOT just the trailing segment — because that
// segment isn't guaranteed to be a counter that only ever increases: a routine
// bump to "17.4.0" resets it to 0, which would otherwise look older than
// "17.3.42" even though it's a strictly newer build. See useSchemaVersionGate.ts.
export const FACTOR_ANALYTICS_MIN_SCHEMA_VERSION = [17, 3, 42]
export const RISK_MIN_SCHEMA_VERSION = [17, 3, 42]
export const ATTRIBUTION_MIN_SCHEMA_VERSION = [17, 3, 44]
// Kept separate from ATTRIBUTION_MIN_SCHEMA_VERSION — Admin Mode (Dashboard
// Manager) and Attribution are unrelated capabilities with independent
// version requirements.
export const ADMIN_MODE_MIN_SCHEMA_VERSION = [17, 3, 43]

export const formatDisplayValue = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '---'

  const str = String(value).trim()
  return str === '' ? '---' : str
}
